import {sliderModel} from './radiusSlider';

var sliderStateStudents = new sliderModel;

export {sliderStateStudents};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/slider/sliderStateStudents.js